import { v4 as uuidv4 } from 'uuid'
import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { toAletheiaItem } from './aletheiaItemFallback'
import { type DniAnalysisTransformer } from './transformers'

export const addToCartTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'add_to_cart') return event
  const { currency = 'TWD', value = 0, items } = event.eventParams
  if (!items) return event
  const campaignCode = 'campaign_code' in event.eventParams ? event.eventParams.campaign_code : undefined
  /**
   * 給 Aletheia 去重複用的 UUID
   */
  const eventId = uuidv4()
  if (platform === AnalyticsPlatforms.META_PIXEL) {
    return {
      eventName: 'AddToCart',
      eventParams: {
        currency,
        value,
        content_type: 'product',
        content_name: items.map(item => item.item_name).join(','),
        contents: items.map(item => ({
          id: item.item_id || 'None',
          quantity: item.quantity || 0,
        })),
        content_ids: items.map(item => item.item_id).filter((id): id is string => id !== undefined),
        campaign_code: campaignCode,
      },
      eventId,
    }
  }
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'add_to_cart',
      eventParams: {
        ...event.eventParams,
        items: event.eventParams.items?.map(item => toAletheiaItem(item, 'add_to_cart')),
      },
      eventId,
    }
  }
  if (platform === AnalyticsPlatforms.OMNICHAT) {
    return {
      eventName: 'add_to_cart',
      eventParams: {
        currency,
        value,
        items: items.map(item => ({
          id: item.item_id || '',
          quantity: item.quantity || 0,
          price: String(item.price || 0),
          brand: item.item_brand || '',
          name: item.item_name || '',
          variant: item.item_variant || '',
        })),
      },
    }
  }
  if (platform === AnalyticsPlatforms.KLAVIYO) {
    const lastItem = items.at(-1)

    return {
      eventName: 'Added to Cart',
      eventParams: {
        $value: value,
        /** 新增的產品資訊 */
        AddedItemProductName: lastItem?.item_name || undefined,
        AddedItemProductID: lastItem?.item_id || undefined,
        AddedItemPrice: Number(lastItem?.price) || undefined,
        AddedItemQuantity: lastItem?.quantity || undefined,
        /** 購物車整體資訊 */
        ItemNames: items.map(item => item.item_name).filter((name): name is string => !!name),
        Items: items.map(item => ({
          ProductID: item.item_id || undefined,
          ProductName: item.item_name || undefined,
          Quantity: item.quantity || undefined,
          Price: Number(item.price) || undefined,
          Variant: item.item_variant || undefined,
          Brand: item.item_brand || undefined,
          RowTotal: Number(item.price) * (item.quantity || 0) || undefined,
        })),
      },
    }
  }
  return event
}
